import React, { useEffect, useRef, useState } from 'react';
import './Topbar.css';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Circle, NotificationsOutlined } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import * as CustomStyle from '../components/CustomStyle'
import ScreenLoader from './ScreenLoader';
import MenuIcon from '@mui/icons-material/Menu';
import axiosInstance from './auth/auth';

const Topbar = ({ isMenuOpen, setIsMenuOpen}) => {
    const [profile, setProfile] = useState({'first_name':'first name', 'last_name':'last name' , 'is_admin':false});
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const wsRef = useRef(null);
    const retryInterval = useRef(null);
    const [webSocketConnected, setWebSocketConnected] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);

    const navigate = useNavigate();
    
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await axiosInstance.get(global.config.server_url + 'user/profile/')
                const data = response.data
                setProfile(data)
            } catch (error) {
                console.log('Topbar Error fetching profile data', error)
            }
        }
        fetchProfile()
    }, [])


    const openSidebar = () => {
        setIsMenuOpen(!isMenuOpen);
        const sidebar = document.querySelector('.sidebar');
        if (sidebar) {
            sidebar.classList.toggle('expanded');
        }
    };



    return (
        <div className="topbar">
            <div className={`title-container ${isMenuOpen ? 'shifted' : ''}`}>
              <MenuIcon className="menu-icon" fontSize="large" onClick={() => setIsMenuOpen(prev => !prev)} />
              <img src="/logo/gotani.png" alt="Logo" className="topbar-logo" />
              <span className="topbar-title"><b>IoT</b></span>
            </div>
            <div className="user-info-container">
                <Link to="/profile">
                    <img src={profile.profile_picture_url ? profile.profile_picture_url : "images/default_user.jpg"} alt="Profile" className="profile-pic" />
                </Link>
                <div className="user-details">
                    <span className="user-name">{profile.first_name} {profile.last_name}</span>
                    <span className="user-role">{profile.is_admin ? 'Admin' : 'User'}</span>
                </div>
            </div>

        </div>
    );
};

export default Topbar;
